import React from 'react'
import { withRouter } from 'react-router'
import classes from './styles.module.scss'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import messages from './messages'
import { WhiteSpace, WingBlank, Flex, List, InputItem, Checkbox, ActionSheet } from 'antd-mobile'
import { requiredRule, cardNumberRule, expireDateRule, securityCodeRule, emailRule } from 'utils/validateRules'
import { intl } from 'utils'
import _ from 'lodash'
import queryString from 'query-string'
import FORM_MESSAGE from 'utils/messages'
import BUTTON_MESSAGE from 'components/Button/messages'

class BankCardForm extends React.Component {
  constructor(props) {
    super(props)
    const payMethod = JSON.parse(sessionStorage.getItem('payMethod')) || {}
    const params = queryString.parse(props.location.search)
    this.state = {
      cardType: params.cardType || payMethod.cardType
    }
  }

  handleNoticeBox = () => {
    this.setState((preState) => ({
      showNotice: !preState.showNotice,
    }))
  }

  handleAgreements = (e) => {
    e.preventDefault()
    const { agreements } = this.props
    const options = _.map(agreements, 'contractName')
    options.push(intl.formatMessage(BUTTON_MESSAGE.cancel))
    ActionSheet.showActionSheetWithOptions(
      {
        options: options,
        cancelButtonIndex: options.length - 1,
        maskClosable: true,
      },
      (buttonIndex) => {
        if (buttonIndex < options.length - 1) {
          const link = agreements[buttonIndex].link
          console.log(link)
          window.location.href = link
        }
      }
    )
  }

  render() {
    const { form, agreements, showOptionalEmail } = this.props
    return (
      <div className={classes.componentsBankCardForm}>
        <List className='am-list-small no-body-border'>
          <WhiteSpace size='lg' />
          <WhiteSpace size='lg' />
          <WingBlank className='font-xs clearfix'>
            <b>
              <FormattedMessage {...messages.listCardNumberLabel} />{' '}
              {form.getFieldDecorator('cardType', {
                initialValue: this.state.cardType,
              })(<InputItem className='dn' />)}
              {this.state.cardType === 'DC' && (
                <span className='gray'>
                  <FormattedMessage {...messages.debitOnly} />
                </span>
              )}
            </b>
            <img
              className='pull-right'
              height={22}
              width={142}
              src={require('./images/channel.png')}
            />
          </WingBlank>
          {form.getFieldDecorator(
            'cardNo',
            cardNumberRule()
          )(
            <InputItem
              clear
              type='tel'
              maxLength={23}
              placeholder={intl.formatMessage(
                messages.listCardNumberPlaceholder
              )}
            />
          )}
          <WhiteSpace size='lg' />
          <WhiteSpace size='lg' />
          <Flex>
            <Flex.Item className={classes.expireInput}>
              <WingBlank className='font-xs'>
                <b>
                  <FormattedMessage {...messages.listExpireLabel} />
                </b>
              </WingBlank>
              {form.getFieldDecorator(
                'expireDate',
                expireDateRule()
              )(
                <InputItem
                  clear
                  type='tel'
                  maxLength={5}
                  placeholder={intl.formatMessage(
                    messages.listExpirePlaceholder
                  )}
                />
              )}
            </Flex.Item>
            <Flex.Item>
              <WingBlank className='font-xs'>
                <b>
                  <FormattedMessage {...messages.listCVVLabel} />
                </b>
                <img
                  className='pull-right'
                  height={16}
                  src={require('./images/CVV.png')}
                />
              </WingBlank>
              {form.getFieldDecorator(
                'cvv',
                securityCodeRule()
              )(
                <InputItem
                  clear
                  type='password'
                  maxLength={3}
                  placeholder={intl.formatMessage(messages.listCVVPlaceholder)}
                />
              )}
            </Flex.Item>
          </Flex>
          <WhiteSpace size='lg' />
          <WhiteSpace size='lg' />
          <WingBlank className='font-xs'>
            <b>
              <FormattedMessage {...messages.listCardHolderNameLabel} />
            </b>
          </WingBlank>
          {form.getFieldDecorator(
            'holderName',
            requiredRule(
              intl.formatMessage(FORM_MESSAGE.formItemCardHolderName)
            )
          )(
            <InputItem
              clear
              type='text'
              maxLength={30}
              placeholder={intl.formatMessage(
                messages.listCardHolderNamePlaceholder
              )}
            />
          )}
          {showOptionalEmail && (
            <React.Fragment>
              <WhiteSpace size='lg' />
              <WhiteSpace size='lg' />
              <WingBlank className='font-xs'>
                <Flex>
                  <Flex.Item>
                    <p
                      className='font-xs clearfix'
                      style={{ lineHeight: '24px' }}
                    >
                      <b>
                        <FormattedHTMLMessage
                          {...messages.listEmailNameLabel}
                        />
                      </b>
                      <span
                        className='iconfont font-mdplus iconquestion pull-right gray'
                        onClick={this.handleNoticeBox}
                      />
                    </p>
                  </Flex.Item>
                </Flex>
              </WingBlank>
              <div
                className={classes.noticeBar}
                style={{ display: this.state.showNotice ? 'block' : 'none' }}
              >
                <WhiteSpace />
                <div className='bg-gray'>
                  <WhiteSpace />
                  <WingBlank className='gray font-xs'>
                    <p>
                      <b>
                        <FormattedMessage {...messages.noticeBox} />
                      </b>
                    </p>
                    <div>
                      <FormattedMessage {...messages.noticeBoxDes} />
                    </div>
                  </WingBlank>
                  <WhiteSpace />
                </div>
              </div>
              <Flex>
                <Flex.Item>
                  {form.getFieldDecorator(
                    'email',
                    emailRule()
                  )(
                    <InputItem
                      clear
                      type='email'
                      placeholder={intl.formatMessage(
                        messages.listEmailNamePlaceholder
                      )}
                    />
                  )}
                </Flex.Item>
              </Flex>
            </React.Fragment>
          )}
          <WhiteSpace size='sm' />
          {agreements && (
            <WingBlank>
              {form.getFieldDecorator(
                'agreements',
                requiredRule(intl.formatMessage(FORM_MESSAGE.formItemAgreement))
              )(<InputItem className='dn' />)}
              <Checkbox.AgreeItem
                onChange={(e) => {
                  console.log(e)
                  form.setFieldsValue({
                    agreements: e.target.checked ? true : undefined,
                  })
                }}
              >
                <p className='font-xs'>
                  <FormattedMessage {...messages.view} />{' '}
                  <span className='green' onClick={this.handleAgreements}>
                    ”<FormattedMessage {...messages.serviceAgreement} />”
                  </span>
                </p>
              </Checkbox.AgreeItem>
            </WingBlank>
          )}
          <WhiteSpace size='lg' />
          <WhiteSpace size='lg' />
        </List>
      </div>
    )
  }
}

export default withRouter(BankCardForm)
